export default "__VITE_ASSET__Bp2A$3Qq__"